import { render, staticRenderFns } from "./goodsListByCard.vue?vue&type=template&id=3f87290c&scoped=true"
import script from "./goodsListByCard.vue?vue&type=script&lang=js"
export * from "./goodsListByCard.vue?vue&type=script&lang=js"
import style0 from "./goodsListByCard.vue?vue&type=style&index=0&id=3f87290c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87290c",
  null
  
)

export default component.exports